module.exports = __webpack_public_path__ + "img/terminal-hse-guideline-1.93eb5015.png";